import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing a view for the summarized cash flow record table.
 * @extends JetView
 */
export default class recordTableFlujoCajaResumidoView extends JetView {
    /**
     * Configures the datatable view.
     * @returns {Object} Configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function

        return {
            view: 'datatable', // Specifies the view type as datatable
            select: true, // Enables row selection
            columns: [
                // Defines the columns of the datatable
                {
                    id: 'package', // Unique identifier for the column
                    header: _('dav'), // Header text, localized
                    fillspace: 2, // Column will fill available space
                    minWidth: 100, // Minimum width of the column
                    sort: 'text', // Sorting type for the column
                    format: dateFormat, // Formatting function for the column data
                },
                {
                    id: 'maintainer', // Unique identifier for the column
                    header: _('ID Usuario'), // Header text, localized
                    width: 100, // Fixed width of the column
                    sort: 'int', // Sorting type for the column
                },
                {
                    id: 'architecture', // Unique identifier for the column
                    header: _('Transacción ID'), // Header text, localized
                    width: 100, // Fixed width of the column
                    sort: 'int', // Sorting type for the column
                },
            ],
            loadahead: devConfig.getDefaultDataFetch(), // Data fetching configuration
            pager: 'pagerA', // Pager configuration for the datatable
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        this.on(this.app, 'user:id', (Id) => {
            // Event listener for user ID changes
            grid.load(
                // Loads data into the grid
                devConfig.geturlApi() + // Base URL for API
                    'es/Financial/GetFlujoCajaResumido3' + // API endpoint
                    '?id=' + // Query parameter for user ID
                    Id, // User ID value
            );
        });
    }
}

// FILE DOCUMENTED
